import { render } from "./ChoiceButton.vue?vue&type=template&id=2af57bda&scoped=true"
import script from "./ChoiceButton.vue?vue&type=script&lang=js"
export * from "./ChoiceButton.vue?vue&type=script&lang=js"

import "./ChoiceButton.vue?vue&type=style&index=0&id=2af57bda&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_webpack@5.107.1_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af57bda"]])

export default __exports__